import React from "react";
import { Layout } from "antd";
import "antd/dist/reset.css";
import "./customLayout.css";
import AppRouter from "./Routes";
import { FooterView } from "../components/home/FooterView";
import { MenuView } from "../components/home/MenuView";
import { HeaderView } from "../components/home/HeaderView";

const { Header, Content, Footer, Sider } = Layout;

export const AnonymousLayout = () => {
  return (
    <div>
      <Layout className="site-layout">
        <Header>
          <HeaderView />
        </Header>

        <MenuView />
        <Content>
          <div>
            <AppRouter />
          </div>
        </Content>
        <Footer style={{ textAlign: "center" }}>
          <FooterView />
        </Footer>
      </Layout>
    </div>
  );
};
